/**
 * Background particle system — subtle ember/sparkle ambiance.
 * Uses a dedicated canvas layered behind everything.
 *
 * @module ui/background
 */

export function initBackground(containerId = 'pd-particles') {
  const canvas = document.getElementById(containerId);
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  if (!ctx) return;

  const MAX_PARTICLES = 60;
  const particles = [];

  function resize() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  // Particle factory
  function spawnEmber() {
    return {
      x: Math.random() * canvas.width,
      y: canvas.height + 10,
      vx: (Math.random() - 0.5) * 0.3,  // gentle horizontal drift
      vy: -(Math.random() * 0.4 + 0.15), // rise slowly
      life: 1,
      decay: Math.random() * 0.003 + 0.002,
      size: Math.random() * 2.5 + 1,
      hue: Math.random() < 0.7 ? 32 : 220, // mostly gold, occasional blue sparkle
      saturation: Math.random() < 0.7 ? 80 : 50,
      lightness: 55 + Math.random() * 25,
    };
  }

  function spawnSparkle() {
    return {
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      vx: 0,
      vy: 0,
      life: 1,
      decay: Math.random() * 0.02 + 0.02,
      size: Math.random() * 1.5 + 0.5,
      hue: 45,
      saturation: 30,
      lightness: 80,
    };
  }

  // Initial fill
  for (let i = 0; i < MAX_PARTICLES; i++) {
    particles.push(Math.random() < 0.8 ? spawnEmber() : spawnSparkle());
  }

  function frame() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    for (let i = particles.length - 1; i >= 0; i--) {
      const p = particles[i];

      p.x += p.vx;
      p.y += p.vy;
      p.life -= p.decay;

      if (p.life <= 0) {
        // Respawn
        if (p.vy < 0) {
          particles[i] = spawnEmber();
        } else {
          particles[i] = spawnSparkle();
        }
        continue;
      }

      const alpha = p.life * 0.5;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fillStyle = `hsla(${p.hue}, ${p.saturation}%, ${p.lightness}%, ${alpha})`;
      ctx.fill();

      // Glow on brighter particles
      if (p.life > 0.6 && p.size > 1.5) {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.size * 2, 0, Math.PI * 2);
        ctx.fillStyle = `hsla(${p.hue}, ${p.saturation}%, ${p.lightness}%, ${alpha * 0.12})`;
        ctx.fill();
      }
    }

    requestAnimationFrame(frame);
  }

  requestAnimationFrame(frame);
}
